import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Popover } from '@material-ui/core';
const ArrowStyle = styled('span')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        top: -7,
        zIndex: 1,
        width: 12,
        right: 20,
        height: 12,
        content: "''",
        position: 'absolute',
        borderRadius: '0 0 4px 0',
        transform: 'rotate(-135deg)',
        background: theme.palette.background.paper,
        borderRight: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
        borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
    },
}));
export function MenuPopover({ children, sx, ...other }) {
    return (_jsxs(Popover, Object.assign({ keepMounted: true, getContentAnchorEl: null, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, PaperProps: {
            sx: {
                mt: 1.5,
                ml: 0.5,
                overflow: 'inherit',
                border: (theme) => `solid 1px ${theme.palette.grey[5008]}`,
                width: 200,
                ...sx,
            },
        } }, other, { children: [_jsx(ArrowStyle, {}, void 0), children] }), void 0));
}
//# sourceMappingURL=MenuPopover.js.map